<h2 mat-dialog-title translate>Start New Application</h2>
<mat-dialog-content>
    <tyl-radio-group
        label='For which year do you want to create the application?'
        [(selected)]='selectedYear'
        [values]="years"
        [labels]="labels"
        [ids]="ids"
        arrange='vertical'
        [required]='false'>
    </tyl-radio-group>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-right'>
        <error-prompt [errorList]='errors'></error-prompt>
        <tyl-button image="next arrow.png" label="Next" (clickEvent)="nextClick()"></tyl-button>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>